// Rótulos de domínio para a UI. Os valores de API continuam em inglês/código;
// o operador e o PCP veem português (ADR-005 D6).

const STATUS_CADASTRO: Record<string, string> = {
  ACTIVE: 'Ativo',
  INACTIVE: 'Inativo',
  DISABLED: 'Desativado',
  DRAFT: 'Rascunho',
  REVOKED: 'Revogado',
  EXPIRED: 'Expirado',
};

const KIND_MATERIAL: Record<string, string> = {
  PRODUTO: 'Produto',
  INSUMO: 'Insumo',
  SERVICO: 'Serviço',
};

const DESTINACAO: Record<string, string> = {
  SUCATA: 'Sucata',
  RETRABALHO: 'Retrabalho',
  REFAZER: 'Refazer',
};

export function rotuloStatus(status: string | null | undefined): string {
  if (!status) return '—';
  return STATUS_CADASTRO[status] ?? status;
}

export function rotuloKindMaterial(kind: string | null | undefined): string {
  if (!kind) return '—';
  return KIND_MATERIAL[kind] ?? kind;
}

export function rotuloDestinacao(destinacao: string | null | undefined): string {
  if (!destinacao) return '—';
  return DESTINACAO[destinacao] ?? destinacao;
}
